import ViewUserProfile from "./ViewUserProfile";

export default ViewUserProfile;
